<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="BOM信息"
      top="5vh"
      width="1200px">
    <div class="bom-first">
      <div class="bom-word">基本信息:</div>
      <div :v-model="bom" class="bom-message">
        <table class="bomTable" style="width: 100%">
          <tr>
            <td class="tableLabel">BOM编号:</td>
            <td>{{bom.bomNo}}</td>
            <td class="tableLabel">物料名称:</td>
            <td>
              {{bom.materialName}}
            </td>
            <td class="tableLabel">物料编号:</td>
            <td>{{bom.materialNo}}</td>
            <td class="tableLabel">创建时间:</td>
            <td>{{bom.createTime}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bom-seond">
      <el-table border :data="bom.bomDetails" height="550px">
        <el-table-column align="center" type="index" label="#" width="55"/>
        <el-table-column align="center" prop="materialNo" width="150" label="物料编号"/>
        <el-table-column align="center" prop="materialName" label="物料名称"/>
        <el-table-column align="center" prop="specification" label="产品规格"/>
        <el-table-column align="center" prop="quantity" width="80" label="数量"/>
        <el-table-column align="center" prop="unit" width="80" label="单位"/>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>

  export default {
    name: "MaterialBom",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        bom: {
          materialNo: "",
          bomDetails: [],
        },
      };
    },
    methods: {
      open(materialNo) {
        this.bom.materialNo = materialNo;
        this.dialogVisible = true;
        this.getBomData();
      },
      getBomData() {
        this.$http.get("basic", `boms/selectByMaterialNo/${this.bom.materialNo}`).then((res) => {
          if (res.success) {
            this.bom = res.data;
            console.log(this.bom);
          }
        });
      },
    },
  };
</script>
<style lang="scss">
.bom-first {
  border: 1px solid #dddddd;
  height: 120px;
  .bom-message {
    padding: 10px;

    table.bomTable {
      font-family: verdana, arial, sans-serif;
      font-size: 11px;
      color: #333333;
      border-width: 1px;
      border-color: #dddddd;
      border-collapse: collapse;
    }

    table.bomTable th {
      text-align: left;
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #dddddd;
      background-color: #d1e6f5;
    }

    table.bomTable td {
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #dddddd;
    }

    .tableLabel {
      width: 10%;
      text-align: right;
      background-color: #d1e6f5;
    }
  }
}

.bom-seond {
  position: relative;
  margin-top: 1%;
  border: 1px solid #dddddd;
}
</style>
